/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import classNames from 'classnames'
import { transformResponseError, transformResponseToList } from 'Common/Utility/formatter'
import { InputSecure } from 'Common/UI/Component/Input'
import Icon from 'Common/UI/Component/Icon'
import { useAssignAccountEmployee, useBrowseAccount } from 'Core/Authentication/API/AccountAPI'

export default function ModalAssignAccount({ employee, open, onClose, onConfirm }) {
    const cancelButtonRef = useRef(null)
    const [password, setPassword] = useState('')
    const [keyword, setKeyword] = useState('')
    const [selectedAccount, selectAccount] = useState(null)

    const assignAccountEmployee = useAssignAccountEmployee({ onSuccess: () => setPassword('') || setKeyword('') || selectAccount('') || onConfirm(), })
    const browseAccount = useBrowseAccount({ currentPage: 1, pageSize: 10, keyword, role: '-Employee' })

    const accounts = transformResponseToList(browseAccount.data)

    const searchAccount = (event) => {
        event.preventDefault();
        browseAccount.refetch()
    }

    const submit = (event) => {
        event.preventDefault()
        assignAccountEmployee.mutate({ ID: selectedAccount.ID, employeeID: employee.ID, password })
    }

    const error = transformResponseError(assignAccountEmployee.error)

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={onClose}>
                <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full">
                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div className="sm:flex sm:items-start">
                                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                                        <Icon.IconOutline.UserPlusIcon className="h-6 w-6 text-blue-600" aria-hidden="true" />
                                    </div>
                                    <div className="mt-3 text-center sm:mt-0  sm:text-left w-full mx-4">
                                        <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                                            Manambahkan Akses
                                        </Dialog.Title>

                                        <div>
                                            <div className="text-center">
                                                <svg
                                                    className="mx-auto h-12 w-12 text-gray-400"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 48 48"
                                                    aria-hidden="true"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M34 40h10v-4a6 6 0 00-10.712-3.714M34 40H14m20 0v-4a9.971 9.971 0 00-.712-3.714M14 40H4v-4a6 6 0 0110.713-3.714M14 40v-4c0-1.313.253-2.566.713-3.714m0 0A10.003 10.003 0 0124 26c4.21 0 7.813 2.602 9.288 6.286M30 14a6 6 0 11-12 0 6 6 0 0112 0zm12 6a4 4 0 11-8 0 4 4 0 018 0zm-28 0a4 4 0 11-8 0 4 4 0 018 0z"
                                                    />
                                                </svg>
                                                <h2 className="mt-2 text-lg font-medium text-gray-900">Pilih akses yang tersedia</h2>
                                                <p className="mt-1 text-sm text-gray-500">
                                                    Silakan pilih akses dibawah ini. akses dibawah ini adalah akses yang belum digunakan sebagai karyawan.
                                                    Jika tidak ada pilihan maka pastikan anda telah membuat akun terlebih dahulu
                                                </p>
                                            </div>
                                            <form onSubmit={searchAccount} className="mt-6 flex">
                                                <label htmlFor="email" className="sr-only">
                                                    Kata Kuncu
                                                </label>
                                                <input
                                                    type="text"
                                                    className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                                    placeholder="Cari email"
                                                    value={keyword}
                                                    onChange={({ target: { value } }) => setKeyword(value)}
                                                />
                                                <button
                                                    type="submit"
                                                    className="ml-4 flex-shrink-0 flex flex-row  items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                >
                                                    <Icon.IconOutline.MagnifyingGlassIcon className='w-4 h-4 text-white' />
                                                    <span className='hidden md:block'>Mencari</span>
                                                </button>
                                            </form>
                                        </div>
                                        <div className="mt-10">
                                            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                                                Semua akss yang tersedia
                                            </h3>
                                            <ul role="list" className="mt-4 border-t border-b border-gray-200 divide-y divide-gray-200">
                                                {accounts.map((account) => (
                                                    <li key={account.ID} className="py-4 flex items-center justify-between space-x-3">
                                                        <div className="min-w-0 flex-1 flex items-center space-x-3">
                                                            <div className="flex-shrink-0">
                                                                {account.avatar ?
                                                                    <img className="h-10 w-10 rounded-full" src={account.avatar} alt="" /> :
                                                                    <span className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-500">
                                                                        <span className="font-medium leading-none text-white">
                                                                            {account.email.split(/[\.@]+/).slice(0, 2).map((part) => `${part[0]}`.toLocaleUpperCase()).join("")}
                                                                        </span>
                                                                    </span>
                                                                }
                                                            </div>
                                                            <div className="min-w-0 flex-1">
                                                                <p className="text-sm font-medium text-gray-900 truncate">{account.email}</p>
                                                                <p className="text-sm font-medium text-gray-500 truncate">{account.created}</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex-shrink-0">
                                                            <button
                                                                onClick={() => selectAccount(selectedAccount?.ID === account.ID ? null : account)}
                                                                type="button"
                                                                className={classNames(
                                                                    "inline-flex items-center py-2 px-3 border border-transparent rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2",
                                                                    (selectedAccount?.ID === account.ID) ? "bg-indigo-500 hover:bg-indigo-200 focus:ring-gray-500 text-white" : "text-gray-900 bg-gray-100 hover:bg-gray-200 focus:ring-indigo-500"
                                                                )}
                                                            >
                                                                {selectedAccount?.ID === account.ID ?
                                                                    <Icon.IconOutline.MinusSmallIcon className="-ml-1 mr-0.5 h-5 w-5 " aria-hidden="true" /> :
                                                                    <Icon.IconSolid.PlusSmallIcon className="-ml-1 mr-0.5 h-5 w-5 " aria-hidden="true" />
                                                                }
                                                                <span className="text-sm font-medium ">
                                                                    {' '}
                                                                    Select <span className="sr-only">{account.email}</span>{' '}
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </li>
                                                ))}
                                                {accounts.length === 0 && (
                                                    <div className='flex flex-col text-center my-5'>
                                                        <svg
                                                            className="mx-auto h-12 w-12 text-gray-400"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                            aria-hidden="true"
                                                        >
                                                            <path
                                                                vectorEffect="non-scaling-stroke"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                strokeWidth={2}
                                                                d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                                                            />
                                                        </svg>
                                                        <h3 className="mt-2 text-sm font-medium text-gray-900">No idle Account/Access</h3>
                                                        <p className="mt-1 text-sm text-gray-500">Please create new Account/Access before using this feature.</p>
                                                        <div className="mt-6">
                                                            <button
                                                                type="button"
                                                                className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                            >
                                                                <Icon.IconSolid.PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
                                                                New Account
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </ul>
                                        </div>
                                        <form onSubmit={submit}>

                                            <div className='mt-2 space-y-2'>
                                                <p className="text-sm text-gray-500">
                                                    Please confirm it with your password
                                                </p>
                                                <div>

                                                    <InputSecure
                                                        label="Password"
                                                        value={password}
                                                        onChange={({ target: { value } }) => setPassword(value)}
                                                        errorMessage={error['body.password']}
                                                    />
                                                </div>

                                            </div>
                                            <div className="mt-2">
                                                <p className="text-sm text-gray-500">
                                                    Are you sure you want to assign {employee.name} an access?
                                                </p>
                                            </div>
                                        </form>

                                    </div>
                                </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                <form onSubmit={submit}>
                                    <button
                                        type="submit"


                                        disabled={assignAccountEmployee.isLoading}
                                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"

                                    >

                                        {assignAccountEmployee.isLoading ?
                                            <span className='flex flex-row gap-2 items-center'><Icon.IconOutline.ArrowPathIcon className='h-3 w-3 animate-spin' />  Saving..</span> :
                                            'Assign'
                                        }

                                    </button>
                                    <button
                                        type="button"
                                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                        ref={cancelButtonRef}
                                        onClick={() => onClose()}
                                    >
                                        Cancel
                                    </button>
                                </form>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
}